import React, { FC, useContext } from "react";
import { Link } from "react-router";
import { ProductsContext } from "../ProductsContext";
import { PRODUCT_DELTA_LIST } from "../ProductConstants";
import Typography from "Components/DesignSystem/Typography/Typography";
import { ChevronRight } from "Components/DesignSystem/Iconography/Icons";
import { FOCUS_RING } from "Components/DesignSystem/focusRing";

interface CategoryItemProps {
  categoryId: string;
  categoryName: string;
  categoryTypeIndex: number;
  categoryIndex: number;
}

/*
  The tile chrome on role tokens (§ 64), replacing raw `whitesmoke-400` /
  `hover:#dee3f6` / an svg-file arrow. Hover is the DS row grammar
  (`surface-sunken`, as in Menu/Dropdown); the legacy tile had no focus state
  at all, so keyboard users could not see where they were.
*/
/* § 268 — the tile no longer states the grid's spacing. `tw-ml-5 tw-mt-3` on every
   tile is how a 20px page inset came to be restated once per category, and it put the
   first tile of each row in charge of the page's left edge. The wrap container owns it
   now (`gap-x-5`/`gap-y-3`), which is the same geometry from one place. */
const TILE_CLASSES =
  "tw-flex-shrink-0 tw-box-border tw-w-[216px] tw-h-14 tw-flex tw-items-center tw-py-3 tw-px-4 tw-gap-2 " +
  `tw-rounded-srf tw-border tw-border-solid tw-border-edge tw-bg-surface tw-text-ink hover:tw-bg-surface-hover-strong ${FOCUS_RING}`;

const CategoryItem: FC<CategoryItemProps> = ({ categoryId, categoryName, categoryTypeIndex, categoryIndex }) => {
  const prodContext = useContext<any>(ProductsContext);
  const onCategoryItemClicked = () => {
    prodContext.resetAttributeData();
  };
  return (
    <Link
      id={`categories-type-${categoryTypeIndex}-item-${categoryIndex}`}
      data-testid={`products-category-${categoryId}`}
      onClick={onCategoryItemClicked}
      to={`${PRODUCT_DELTA_LIST}/${categoryId}`}
      className={TILE_CLASSES}
    >
      <Typography variant="body-primary" as="span" className="tw-flex-1">
        {categoryName}
      </Typography>
      <ChevronRight size={12} aria-hidden="true" className="tw-shrink-0 tw-text-ink-tertiary" />
    </Link>
  );
};

export default CategoryItem;
